module.exports = __webpack_public_path__ + "img/B.2dd999e3.jpg";